// NeevCoinsBar.js — Gold coin counter for NeevStar navbar
import React, { useState, useEffect, useRef } from 'react';

const styles = `
@keyframes coinFloat {
  0%   { opacity: 1; transform: translateY(0) scale(1); }
  80%  { opacity: 1; transform: translateY(-48px) scale(1.1); }
  100% { opacity: 0; transform: translateY(-64px) scale(0.8); }
}
@keyframes coinPulse {
  0%, 100% { transform: scale(1); }
  50%       { transform: scale(1.18); }
}
.neev-coin-float {
  position: fixed;
  pointer-events: none;
  font-size: 13px;
  font-weight: 900;
  color: #FFD600;
  text-shadow: 0 1px 4px rgba(0,0,0,0.4);
  animation: coinFloat 1.1s ease-out forwards;
  z-index: 9999;
  font-family: 'Nunito', sans-serif;
}
.neev-coin-icon {
  display: inline-block;
  animation: coinPulse 2s ease-in-out infinite;
}
`;

let floatId = 0;

export function triggerCoinFloat(amount, anchorEl) {
  const id = ++floatId;
  const el = document.createElement('div');
  el.className = 'neev-coin-float';
  el.textContent = `+${amount} 🪙`;
  el.id = `coin-float-${id}`;

  // Position near the coins bar or top-right
  const rect = anchorEl?.getBoundingClientRect();
  el.style.top = rect ? `${rect.bottom + 4}px` : '60px';
  el.style.left = rect ? `${rect.left}px` : 'calc(100vw - 80px)';

  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1200);
}

export default function NeevCoinsBar({ coins = 0 }) {
  const [displayed, setDisplayed] = useState(coins);
  const prevRef = useRef(coins);
  const barRef = useRef(null);

  // Inject styles once
  useEffect(() => {
    if (!document.getElementById('neev-coins-style')) {
      const tag = document.createElement('style');
      tag.id = 'neev-coins-style';
      tag.textContent = styles;
      document.head.appendChild(tag);
    }
  }, []);

  // Animate counter when coins change
  useEffect(() => {
    const diff = coins - prevRef.current;
    if (diff > 0) {
      triggerCoinFloat(diff, barRef.current);
      // Smooth count-up
      const steps = 20;
      const step = diff / steps;
      let current = prevRef.current;
      let i = 0;
      const timer = setInterval(() => {
        i++;
        current += step;
        setDisplayed(Math.round(i === steps ? coins : current));
        if (i >= steps) clearInterval(timer);
      }, 30);
      return () => clearInterval(timer);
    } else {
      setDisplayed(coins);
    }
    prevRef.current = coins;
  }, [coins]);

  return (
    <div
      ref={barRef}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        background: 'rgba(255,214,0,0.18)',
        border: '1.5px solid rgba(255,214,0,0.5)',
        borderRadius: 20,
        padding: '4px 10px',
        cursor: 'default',
        userSelect: 'none',
      }}
    >
      <span className="neev-coin-icon" style={{ fontSize: 15 }}>🪙</span>
      <span style={{
        fontSize: 13,
        fontWeight: 900,
        color: '#FFD600',
        fontFamily: "'Nunito', sans-serif",
        minWidth: 28,
        textAlign: 'right',
        textShadow: '0 1px 3px rgba(0,0,0,0.3)',
      }}>
        {displayed.toLocaleString()}
      </span>
    </div>
  );
}
